<!--
 * @Description: 星图商城列表详情页
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2022-11-30 14:32:16
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-01-11 17:31:11
 -->
<template>
  <div class="shopdetails">
    <div class="shopImg">
      <img
        v-for="(item, index) in dataList"
        :key="index"
        :src="
          `${baseUrlAddr}/front/picUploadAndDownload/download3?fileName=` + item.url
        "
        alt=""
      />
    </div>
    <i
      class="iconfont icon-zuojiantou_huaban leftArrow"
      @click="handleBack"
    ></i>
    <button @click="handleShoping" class="shoping">立即购买</button>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  //跳转前判断是从商品列表进来的就缓存页面不刷新
  beforeRouteLeave(to, from, next) {
    if (to.name === "shopList") {
      to.meta.keepAlive = true;
    }
    next();
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      id: "",
      dataList: [],
      shopingUrl: "",
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.handleGetInfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    //返回上一页
    handleBack() {
      this.$router.go(-1);
    },
    //获取数据
    handleGetInfo() {
      this.id = this.$route.query.id;
      this.shopingUrl= this.$route.query.targetUrl;
      this.request
        .get("/front/device/productDetail/queryByproduct?productId=" + this.id)
        .then((res) => {
          console.log("zx", res.data);
          this.dataList = res.data;
          
        });
    },
    //点击立即购买
    handleShoping() {
      location.href = this.shopingUrl;
    },
  },
};
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
// @import url('@/assets/shopFont/iconfont.css');
.shopdetails {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  .shopImg {
    position: relative;
    top: -19px;
    height: 850px;
    text-align: center;
    overflow-y: scroll;
    img {
      width: 850px;
    }
  }
  .leftArrow {
    position: absolute;
    font-size: 30px;
    top: 0;
    left: 20px;
    cursor: pointer;
  }
  .shoping {
    position: fixed;
    left: 46%;
    bottom: 40px;
    color: #fff;
    text-align: center;
    line-height: 35px;
    width: 310px;
    height: 45px;
    background-color: rgb(221, 48, 48);
    border: 1px solid rgb(221, 48, 48);
    border-radius: 21px;
    cursor: pointer;
  }
}
</style>
